export const EVENT = {
  CATEGORIES: {
    concert: "Concerto",
    theater: "Teatro",
    workshop: "Oficina",
    exhibition: "Exposição",
  },
  defaults: {
    date: new Date(),
  },
};
